import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';
import BEMHelper from 'react-bem-helper';
import { Header, Segment, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { TrackEvent } from '../../../../Services/TrackEvent';
import SettingsProperty from '../../SettingsProperty';
import { Grid } from 'semantic-ui-react';
import { NEXT_PUBLIC_SITE_URL } from '../../../../settings';

import './NewMembershipBlock.scss';

const bem = BEMHelper({
  name: 'SettingsMembershipBlock',
  outputIsString: true,
});

function NewMembershipBlock(props) {
  const { newPlatform } = props;

  const planStatus =
    newPlatform && newPlatform.subscription && newPlatform.subscription.status;
  const planName =
    newPlatform &&
    newPlatform.subscription &&
    newPlatform.subscription.pricing_plan &&
    newPlatform.subscription.pricing_plan.name;
  const hasPurchasedChallenges =
    newPlatform && newPlatform.purchases && newPlatform.purchases.length > 0;

  return (
    <>
      {planStatus && (
        <Segment fluid className={cx('settings-block', bem())}>
          <Header as="h2" className="settings-block-title">
            Challenge Billing
          </Header>
          <SettingsProperty
            name="Plan"
            valueChild={planStatus ? planName : 'None'}
          />

          <SettingsProperty
            name="Status"
            valueChild={
              <span className={bem('trial-status')}>{planStatus}</span>
            }
          />
          <div>
            <Button
              onClick={() => [
                window.open(
                  `${NEXT_PUBLIC_SITE_URL}settings/billing?pass=true`,
                  '_blank'
                ),
                TrackEvent('settings-clicked-subscription-details'),
              ]}
              color="orange"
              className={bem('section-btn')}
            >
              Manage Challenge Billing
            </Button>
          </div>
          <p className={bem('popup-help')}>
            Your subscription is managed by <b> GetMotivated.ai</b>
          </p>
          <p className={bem('popup-help on-mobile')}>
            If you are having issues on mobile, try checking from desktop.
          </p>
        </Segment>
      )}
      {hasPurchasedChallenges && (
        <Segment fluid className={cx('settings-block', bem())}>
          <Header as="h2" className="settings-block-title">
            Purchased Challenges
          </Header>
          {!planStatus && (
            <p className={bem('description')}>
              Your purchases are managed by <b>Getmotivated.ai</b>
            </p>
          )}

          {/* <div className="mt-2 space-y-2"> */}
          <Grid>
            {newPlatform.purchases.map((purchase, index) => (
              <Fragment key={index}>
                <Grid.Column tablet={6} className={bem('title-col')}>
                  <span className={bem('title')}>
                    {purchase && purchase.challenge && purchase.challenge.title}
                  </span>
                </Grid.Column>
                <Grid.Column tablet={6}>
                  <Button
                    color="orange"
                    size="tiny"
                    onClick={() => {
                      if (
                        purchase &&
                        purchase.challenge &&
                        purchase.challenge.slug
                      ) {
                        window.open(
                          `${NEXT_PUBLIC_SITE_URL}challenge/${purchase.challenge.slug}`,
                          '_blank'
                        );
                      }
                    }}
                  >
                    View
                  </Button>
                </Grid.Column>
              </Fragment>
            ))}
          </Grid>
          <Button
            onClick={() => [
              window.open(
                `${NEXT_PUBLIC_SITE_URL}settings/billing?pass=true`,
                '_blank'
              ),
              TrackEvent('settings-clicked-subscription-details'),
            ]}
            color="orange"
            className={bem('section-btn')}
          >
            Manage Challenge Billing
          </Button>

          {!planStatus && (
            <div className={` ${bem('banner')}`}>
              <h4 className={`ui header ${bem('header')}`}>
                Want unlimited access?
              </h4>
              <p className={bem('description')}>
                Get access to all challenges with our All Access Pass
              </p>
              <a
                href={`${NEXT_PUBLIC_SITE_URL}all-access`}
                target="_blank"
                rel="noopener noreferrer"
                className={`ui small header ${bem('link')}`}
              >
                Learn more about All Access
                <i
                  className="arrow right icon"
                  style={{ marginLeft: '0.5rem' }}
                ></i>
              </a>
            </div>
          )}
          {planStatus && (
            <p className={bem('popup-help')}>
              Your purchases are managed by <b>Getmotivated.ai</b>
            </p>
          )}
        </Segment>
      )}
    </>
  );
}

NewMembershipBlock.propTypes = {
  newPlatform: PropTypes.shape({
    purchases: PropTypes.array,
    subscription: PropTypes.shape({
      status: PropTypes.string,
      pricing_plan: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }),
};

const mapStateToProps = (state) => ({ newPlatform: state.newPlatform });

const ConnectedMembership = connect(mapStateToProps, {})(NewMembershipBlock);

export default withRouter(ConnectedMembership);
